// The 404 page — what any unknown path renders to.
//
// Reached two ways: a fresh request Netlify could not match to a real file or
// redirect gets served dist/404.html with a genuine 404 status (see
// netlify.toml and scripts/prerender-seo.mjs), and a client-side navigation
// to a path App.jsx's "*" route catches renders this same component, no
// reload involved. Either way the reader sees the same page.
//
// It says plainly that the page does not exist rather than quietly becoming
// the homepage, and offers the two places a lost reader is likely headed: the
// start page, and the publisher index, which is the closest thing this app
// has to a directory of everything it covers.

import React from 'react';
import { Link } from 'react-router-dom';
import RapportvaktShell, { BrandMark, useRvLang } from '../components/rapportvakt/Shell';
import { Glyph } from '../components/rapportvakt/Delivery';
import { RAPPORTVAKT_LANDING_PATH, RAPPORTVAKT_PUBLISHERS_PATH } from '../config/rapportvakt';
import { getRapportvaktNotFoundSeo } from '../config/seoRoutes';

function NotFoundBody() {
  const { t } = useRvLang();

  return (
    <main className="rv__inner">
      <div className="rv-404">
        <span className="rv-404__mark" aria-hidden="true">
          <BrandMark />
        </span>
        <h1 className="rv-404__title">{t.notFoundTitle}</h1>
        <p className="rv-404__body">{t.notFoundBody}</p>
        <div className="rv-404__actions">
          <Link className="rv-btn rv-btn--primary" to={RAPPORTVAKT_LANDING_PATH}>
            {t.notFoundHome}
            <Glyph name="arrow" size={13} />
          </Link>
          <Link className="rv-btn rv-btn--ghost" to={RAPPORTVAKT_PUBLISHERS_PATH}>
            {t.notFoundPublishers}
          </Link>
        </div>
      </div>
    </main>
  );
}

export default function RapportvaktNotFoundPage() {
  return (
    <RapportvaktShell seo={getRapportvaktNotFoundSeo()}>
      <NotFoundBody />
    </RapportvaktShell>
  );
}
